<template>
  <div class="account-right-item attention">
    <div class="bk-form" v-show="!isDataLoading">
    	<div class="upload-form">
	      <div class="bk-form-item">
	        <label class="bk-label">收费模式：</label>
	        <div class="bk-form-content">
	          <label class="bk-form-radio" v-for="(item,index) in tradeMode.model">
	            <input class="bk-radio-text" type="radio" name="radio1"  :value="item.type" checked="checked">
	            <i class="bk-radio-text">{{item.title}}</i>
	          </label>
	        </div>
	      </div>
	      <div>
	        <div class="bk-form-item" style="margin-top: 20px">
	          <label class="bk-label"><span class="bk-label-required">*</span> 收费价格：</label>
	          <div class="bk-form-content">
	            <span class="bk-form-span" style="color: #ff6600;">免费</span>
	          </div>
	        </div>
	        <div class="bk-form-item">
	          <label class="bk-label"><span class="bk-label-required"></span> 开源协议：</label>
	          <div class="bk-form-content">
		          <bk-selector :list="tradeMode.openSource.list" :selected.sync="tradeMode.openSource.selected"
		            style="width: 310px; display: inline-block;">
		          </bk-selector>
		        </div>
	        </div>
	        <div class="bk-form-item">
	          <label class="bk-label"><span class="bk-label-required"></span> 服务支持：</label>
	          <div class="bk-form-content">
	            <bk-selector :list="tradeMode.support.list" :selected.sync="tradeMode.support.selected"
	              style="width: 310px; display: inline-block;">
	            </bk-selector>
	            <!-- <i class="bk-icon icon-attention"></i> -->
	          </div>
	        </div>
	        <div class="bk-form-item">
	          <label class="bk-label"><span class="bk-label-required"></span> 开源链接：</label>
	          <div class="bk-form-content">
	            <input type="url" class="bk-form-input" v-bind:class="{'bk-input-checked': check.test_url.isShow}"  @input="checkValidate" v-model="tradeMode.freeUrl" placeholder="请选择" style="width: 614px">
	          </div>
	        </div>
	      </div>
	      <!-- <div v-else-if="tradeMode.selectedModel === 1">
	        <div class="bk-form-item" style="margin-top: 20px">
	          <label class="bk-label"><span class="bk-label-required">*</span> 收费价格：</label>
	          <div class="bk-form-content">
	            <input type="number" class="bk-form-input" v-model="tradeMode.price" name="validation_name" placeholder="建议售价 ¥20" style="width: 308px">
	            <i class="bk-icon icon-attention"></i>
	          </div>
	        </div>
	        <div class="bk-form-item">
	          <label class="bk-label"><span class="bk-label-required">*</span> 服务支持：</label>
	          <div class="bk-form-content">
	            <bk-selector :list="tradeMode.support.list" :selected.sync="tradeMode.support.selected"
	              style="width: 310px; display: inline-block;">
	            </bk-selector>
	            <i class="bk-icon icon-attention"></i>
	          </div>
	        </div>
	      </div> -->
	      <!-- <div>
	        <div class="bk-form-item" style="margin-top: 20px">
	          <label class="bk-label"><span class="bk-label-required">*</span> 收费价格：</label>
	          <div class="bk-form-content">
	            <input type="number" class="bk-form-input" name="validation_name" placeholder="建议售价 2000G" style="width: 308px" v-model="tradeMode.price">
	            <i class="bk-icon icon-attention"></i>
	          </div>
	        </div>
	        <div class="bk-form-item">
	          <label class="bk-label"><span class="bk-label-required">*</span> 服务支持：</label>
	          <div class="bk-form-content">
	            <bk-selector :list="tradeMode.support.list" :selected.sync="tradeMode.support.selected"
	              style="width: 310px; display: inline-block;">
	            </bk-selector>
	            <i class="bk-icon icon-attention"></i>
	          </div>
	        </div>
	      </div> -->
			</div>

      <div class="upload-action">
	      <a :class="['bk-button', 'bk-primary',{'is-loading':saveFlag === false}]" id="submit" @click="save" title="提交">
					<span>提交</span>
				</a>
				
	      <a class="bk-button bk-return" title="返回" @click="back">
	        <span>返回</span>
	      </a>
	    </div>
    </div>
    <!-- 弹出框子组件 -->
    <v-alert :options="options"></v-alert>
  </div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
	import vAlert from '../../alert.vue'

  export default {
    data () {
      return {
				saveFlag: true, //提交按钮
      	isDataLoading: true,
      	options: {
          msgText: "",
          msgIsSuccess: true
        },
        check: {
        	test_url: {
            isShow: false,
            tips: ''
          }
        },
        isActive: false,
      	tradeMode: { // 设置交易模式
          model: [
            {
              title:"免费",
              type: 0
            }
            // {
            //   title:"人民币",
            //   type: 1
            // },
            // {
            //   title:"鲸币",
            //   type: 2
            // }
          ], 
          selectedModel: 0,
          openSource: { // 开源协议
            list: [],
            selected: -1
          },
          support: { // 服务支持
            list: [],
            selected: -1
          },
          price: '',
          freeUrl: ''
        }
      }
    },
    components: {
			vAlert
		},
    methods: {
      selected () {
        console.log(11);
      },
      /*
       ** 获取默认列表
       */
      getSelectedList() {
        axios.get(myUrl + 'core/product/labels/').then((res) => {
          let resData = res.data;
          if (resData.result) {
            this.tradeMode.openSource.list = resData.data.free_choices; // 设置交易模式 -> 开源协议
            this.tradeMode.support.list = resData.data.support_choices; // 设置交易模式 -> 
          } else {
            // 错误提示
            this.options = {
              msgIsSuccess: false,
              msgText: res.message
            }
          }
        })
      },
      /*
       ** 获取产品信息
       */
      getBasicInfo() {
        const app_id = this.$route.params.wid;
        axios.get(myUrl + `core/product/info/${app_id}/`, {
          params: {
            keyword: 'trade'
          }
        }).then((res) => {
        	this.isDataLoading = false
          if (res.data.result) {
          	let data = res.data.data.app_basic
            this.tradeMode.selectedModel = data.pay_choices
            this.tradeMode.openSource.selected = data.protocol
            this.tradeMode.support.selected = data.support
            this.tradeMode.price = data.price
            this.tradeMode.freeUrl = data.free_url
          } else {
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        })
      },
      checkParams (params) {
      	if (this.tradeMode.selectedModel !== 0) {
      		if (this.tradeMode.price === '') {
      			this.options = {
              msgIsSuccess: false,
              msgText: '请输入收费价格'
            }
            return false
      		}
      	}
      	return true
      },
      save () {
				this.saveFlag = false;
        setTimeout(() => {
          this.saveFlag = true
        }, 9000)
      	let workId = this.$route.params.wid
      	if (this.tradeMode.selectedModel === 0) {
      		this.tradeMode.price = 0
      	}
      	// if (this.check.test_url.isShow) {
      	// 	this.options = {
	      //     msgIsSuccess: false,
	      //     msgText: '开源链接格式不正确！'
	      //   }
      	// 	return false
      	// }
      	let params = {
      		keyword: 'trade',
      		trade: 	JSON.stringify({
      			free_url: this.tradeMode.freeUrl,
				    price: this.tradeMode.price,
				    mode: this.tradeMode.selectedModel,
				    protocol: this.tradeMode.openSource.selected,
				    support: this.tradeMode.support.selected
      		})
      	}
      	if (this.checkParams(params)) {
	        axios.post(myUrl + `core/product/update/${workId}/`, qs.stringify(params)).then((response) => {
	          let res = response.data
	          if (res.result) {
							this.saveFlag = true
	            this.options = {
	              msgIsSuccess: true,
	              msgText: '更新成功'
	            };
	          } else {
	            this.options = {
	              msgIsSuccess: false,
	              msgText: res.message
	            };
	          }
	        }, reject => {
	          this.options = {
	            msgText: reject.message,
	            msgIsSuccess: false
	          }
	        })
        }
      },
      /*
       ** 验证输入合法性
       */
      checkValidate(type) {
        // let urlReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/
        // if (!urlReg.test(this.tradeMode.freeUrl)) {
        //   this.check.test_url.isShow = true;
        //   this.isActive = true;
        //   this.check.test_url.tips = "请输入合法的体验地址";
        // } else {
        // 	this.check.test_url.isShow = false;
        // 	this.isActive = false;
        // }
      },
      back () {
      	window.history.go(-1)
      }
    },
    created () {
    	this.getSelectedList()
    	this.getBasicInfo()
    }
  }
</script>

<style media="screen" lang="scss" scoped>
  .attention{
    min-height: 650px;
    padding: 15px 45px 45px;
  }
  .bk-form{
    width: 911px;
    margin-left: -45px;
    margin-right: -45px;
  }
.bk-form .bk-label {
	width: 126px;
	text-align: right;
	vertical-align: middle;
	float: left;
	font-size: 14px;
	font-weight: normal;
	color: #a6a6a6;
	line-height: 1;
	box-sizing: border-box;
	padding: 10px 10px 10px 0
}

.bk-input-checked:focus {
	border-color: #F72239;
}

.bk-form .bk-form-content {
	width: auto;
	position: relative;
}

.bk-form .bk-form-content>.bk-tip-text {
	font-size: 14px;
	color: #737987;
	margin: 10px 0 0 0
}

.bk-form .bk-form-content>.bk-form-tip {
	padding: 0;
	margin: 10px 0 0 0;
	position: relative;
	height: auto;
	line-height: 1;
	left: 0
}

.bk-form .bk-form-content>.bk-form-tip .bk-tip-text {
	float: none;
	vertical-align: middle
}

.bk-form .bk-form-content>.bk-form-tip .bk-badge {
	margin-right: 5px
}

.bk-form ::placeholder {
	color: #cccccc
}

.bk-form::after,.bk-form .bk-form-item::before {
	display: table;
	content: "";
	clear: both;
	visibility: hidden;
	font-size: 0
}

.bk-form input:-webkit-autofill,.bk-form textarea:-webkit-autofill,.bk-form select:-webkit-autofill {
	background: #fff !important
}

.bk-form-item {
	position: relative;
    margin-top: 20px;
}
.bk-inline-form{
    font-size: 0;
    .bk-form-item {
        margin-top: 0;
        display: inline-block
    }
}

.bk-form-item label {
	margin-bottom: 0
}

.bk-form-item.is-required .bk-label {
	position: relative
}

.bk-form-item.is-required .bk-label:before {
	content: '*';
	color: #ff5656;
	position: relative;
	margin: 2px 6px 0 0;
	display: inline-block;
	vertical-align: middle
}


.bk-form-input,.bk-form-password,.bk-form-select,.bk-form-textarea {
	box-sizing: border-box;
	height: 36px;
	line-height: 1;
	color: #4f515e;
	background-color: #fff;
	border-radius: 2px;
	width: 100%;
	box-sizing: border-box;
	border: 1px solid #e6e6e7;
	padding: 0 10px;
	font-size: 14px;
	text-align: left;
	vertical-align: middle;
	outline: none;
	resize: none;
	transition: border linear .2s
}

.bk-form-input:focus,.bk-form-password:focus,.bk-form-select:focus,.bk-form-textarea:focus {
	border-color: #3c96ff !important;
	background-color: #fff !important;
	color: #737987 !important
}

.bk-form-input:focus::placeholder,.bk-form-password:focus::placeholder,.bk-form-select:focus::placeholder,.bk-form-textarea:focus::placeholder {
	color: #cccccc !important
}

.bk-form-input::placeholder,.bk-form-password::placeholder,.bk-form-select::placeholder,.bk-form-textarea::placeholder {
	color: #cccccc
}

.bk-form-input[disabled],.bk-form-input[readonly],.bk-form-password[disabled],.bk-form-password[readonly],.bk-form-select[disabled],.bk-form-select[readonly],.bk-form-textarea[disabled],.bk-form-textarea[readonly] {
	background-color: #fafafa
}

.bk-form-input[disabled],.bk-form-password[disabled],.bk-form-select[disabled],.bk-form-textarea[disabled] {
	color: #ccc
}

.bk-form-select {
	line-height: 32px;
	padding-left: 0\9\0;
	padding-right: 0\9\0
}

.bk-form-textarea {
	min-height: 60px;
	padding: 10px
}

.bk-form-mini .bk-form-input,.bk-form-mini .bk-form-password,.bk-form-mini .bk-form-select,.bk-form-mini .bk-form-textarea {
	height: 24px;
	font-size: 12px
}

.bk-form-small .bk-form-input,.bk-form-small .bk-form-password,.bk-form-small .bk-form-select,.bk-form-small .bk-form-textarea {
	height: 32px;
	font-size: 12px
}

.bk-form-large .bk-form-input,.bk-form-large .bk-form-password,.bk-form-large .bk-form-select,.bk-form-large .bk-form-textarea {
	height: 42px;
	font-size: 14px
}

.bk-form-larger .bk-form-input,.bk-form-larger .bk-form-password,.bk-form-larger .bk-form-select,.bk-form-larger .bk-form-textarea {
	height: 54px;
	font-size: 18px
}

.bk-form-tip {
	height: 36px;
	line-height: 36px;
	padding: 0 10px 0 35px;
	position: relative;
	position: absolute;
	left: 100%;
	top: 0
}

.bk-form-tip .bk-badge {
	vertical-align: middle
}

.bk-form-tip .bk-tip-text {
	float: left;
	font-size: 14px;
	color: #737987;
	display: inline-block;
	padding: 0;
	margin: 0;
	white-space: nowrap
}

.bk-form.bk-form-vertical .bk-form-item.bk-form-action {
	margin-top: 20px
}
.bk-button {
	float: left;
	margin-right: 10px;
	height: 36px;
	line-height: 34px;
	display: inline-block;
	white-space: nowrap;
	outline: none;
	cursor: pointer;
	white-space: nowrap;
	-webkit-appearance: none;
	width: 93px;
	text-align: center;
	vertical-align: middle;
	font-size: 14px;
	background: #fff;
	border: 1px solid #e6e6e7;
	border-radius: 2px;
	box-sizing: border-box;
	color: #737987;
	text-decoration: none;
	transition: background-color ease 0.3s;
	-webkit-transition: background-color ease 0.3s
}

.bk-button:hover,.bk-button.hover {
	background-color: #fafafa;
	color: #737987;
	text-decoration: none
}

.bk-button:active,.bk-button.active {
	background-color: #eee;
	color: #737987;
	text-decoration: none
}
    .bk-button.bk-primary {
	background: #3c96ff;
	border-color: #3c96ff;
	color: #fff
}

.bk-button.bk-primary:hover,.bk-button.bk-primary.hover {
	background-color: #0082ff;
	border-color: #0082ff;
	opacity: 1
}

.bk-button.bk-primary:active,.bk-button.bk-primary.active {
	background-color: #0978e2;
	border-color: #0978e2
}
.bk-icon {
    display: inline-block;
}
.icon-attention {
    width: 16px;
    height: 16px;
    position: relative;
    top: 5px;
    margin-left: 5px;
    background: url(../../../images/application_detail/icon-info.png) no-repeat;
}
    .bk-form-radio {
	font-size: 14px;
	color: #666666;
	margin-right: 30px;
	line-height: 18px;
	display: inline-block;
	padding: 7px 0
}

.bk-form-radio .bk-radio-text {
	font-style: normal;
	font-weight: normal;
	cursor: pointer;
	vertical-align: middle
}

.bk-form-radio input[type=radio] {
	width: 18px;
	height: 18px;
	outline: none;
	visibility: visible;
	cursor: pointer;
	vertical-align: middle;
	background-color: #fff;
	background-image: url(http://open.oa.com/static_api/v3/bk/images/bk_check.png);
	display: inline-block;
	background-position: 0 0;
	-webkit-appearance: none;
	margin: 0 5px 0 0
}

.bk-form-radio input[type=radio]:checked {
	background-position: -33px 0
}

.bk-form-radio input[type=radio]:checked[disabled] {
	color: #ccc;
	background-position: -99px 0
}

.bk-form-radio input[type=radio][disabled] {
	background-position: -66px 0;
	cursor: default
}

.bk-form-radio input[type=radio][disabled]+.bk-radio-text {
	color: #ccc;
	cursor: default
}
.bk-form-span {
    line-height: 18px;
    display: inline-block;
    padding: 7px 0;
    &.red {
        color: #ff5656;
    }
}
.bk-label-required {
    width: 5px;
    height: 6px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 14px;
    letter-spacing: 0px;
    color: #ff6600;
}

.upload-action {
	display: table;
  padding: 0 30px 60px 168px !important;
}
.upload-form {
	padding: 10px 20px 40px 20px;
}

.tips {
	background: #090b1a;
	position: absolute;
	white-space: nowrap;
	color: #fff;
	top: -40px;
	left: 50%;
	padding: 0 10px;
	height: 30px;
	line-height: 30px;
	border-radius: 2px;
	text-align: center;
	transform: translateX(-50%);
	-o-transform: translateX(-50%);
	-ms-transform: translateX(-50%);
	-moz-transform: translateX(-50%);
	-webkit-transform: translateX(-50%);
	&:after {
  	content: '';
	  position: absolute;
	  left: 50%;
	  bottom: -14px;
	  width: 0;
	  height: 0;
	  border: 10px solid #090b1a;
	  border-color: #090b1a transparent transparent transparent;
	  margin-left: -10px;
  }
}
.bk-input-checked {
		border-color: #ff6600 !important;
	}
</style>



// WEBPACK FOOTER //
// trading_mode.vue?548c1b2e